/**
 * Make the tabs show the active panel
 */
document.addEventListener('DOMContentLoaded', function() {
    let tabContainers = document.querySelectorAll('.tabs');
    if(!tabContainers) return;

    tabContainers.forEach((tabContainer) => {
        let tabSelectors = tabContainer.querySelectorAll('.selector');
        let tabPanels = tabContainer.querySelectorAll('.tab-panel');

        tabSelectors.forEach((selector) => {
            selector.addEventListener('click', function() {
                let targetID = selector.getAttribute('id');

                tabSelectors.forEach((tsel) => {
                    tsel.classList.remove('active');
                })
                tabPanels.forEach((panel) => {
                    panel.classList.remove('active');
                });

                selector.classList.toggle('active');
                tabContainer.querySelector(`.tab-panel[data-target="${targetID}"]`).classList.toggle('active');
            });
        });
    });

    let dropDownHeaders = document.querySelectorAll('.dropdown-header');
    if(!dropDownHeaders) return;

    dropDownHeaders.forEach((dropDownHeader) => {
        let listToShow = dropDownHeader.nextElementSibling;

        dropDownHeader.addEventListener('click', function() {
            const isActive = dropDownHeader.classList.contains('active');

            if (isActive) {
                setTimeout(() => dropDownHeader.classList.remove('active'), 350);
                listToShow.classList.remove('active');
                listToShow.style.maxHeight = '0px';
            } else {
                dropDownHeader.classList.add('active');
                listToShow.classList.add('active');
                listToShow.style.maxHeight = listToShow.scrollHeight + 'px';
            }
        });
    });

    // When resizing past the mobile breakpoint, clear inline maxHeight so
    // desktop CSS is no longer overridden by the mobile JS-set values.
    window.addEventListener('resize', function() {
        if (window.innerWidth >= 768) {
            dropDownHeaders.forEach((dropDownHeader) => {
                let listToShow = dropDownHeader.nextElementSibling;
                dropDownHeader.classList.remove('active');
                listToShow.classList.remove('active');
                listToShow.style.maxHeight = '';
            });
        }
    });

    /**
     * Ensure vertical tabs sections are tall enough for their
     * absolutely-positioned text wrappers.
     */
    function updateVerticalTabsHeight() {
        let verticalSections = document.querySelectorAll('.tabbed-content .vertical-tabs');

        verticalSections.forEach((section) => {
            let block = section.closest('.page-block .container-fluid');
            if(!block) return;

            let textWrappers = section.querySelectorAll('.tab-panel .text-wrapper');
            let tallest = 0;

            textWrappers.forEach((wrapper) => {
                tallest = Math.max(tallest, wrapper.offsetHeight);
            });

            if(tallest > 0) {
                let margin = 80;
                let minHeight = tallest + margin;
                block.style.minHeight = minHeight + 'px';
            }
        });
    }

    updateVerticalTabsHeight();
    window.addEventListener('resize', updateVerticalTabsHeight);
});